import { useSelector } from "react-redux";
import SelectedVINOrPA from "./SelectedVINOrPA";
import { StarSpan } from "./CamerasAndOtherAccessories";
import { TextWrapper, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import "../../../constants/common/StyleOnlyForScreenReader.css";
import AccessibleAutocompleteDropdown from "./AutocompleteDropdown/AccessibleAutocompleteDropdown";
import PropTypes from "prop-types";

function CurrentVehicleSearch({
  selectedVinOrPA,
  setSelectedVinOrPA,
  searchHandler,
  setSelectedAccessories,
  setHighlightAccessories,
  getDeviceType,
  isWarning,
  isBlockingErrorOccured,
}) {
  const {
    vehicleAndAssetList: { vehicles },
  } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  return (
    <Wrapper display="flex" flexDirection="column" alignItems="flex-start" marginTop={isWarning ? "1rem" : "1.5rem"}>
      <h3 className="sr-only" tabIndex="-1">
        Current vehicle or powered asset
      </h3>
      <TextWrapper fontSize="1.5rem" fontWeight="700" lineHeight="2rem" aria-hidden="true" tabIndex="-1">
        Current vehicle or powered asset
      </TextWrapper>
      <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1rem !important" lineHeight="1.25rem">
        Fill in the details of the vehicle or powered asset that the tracker is currently installed in.
      </TextWrapper>
      <TextWrapper fontSize="0.75rem" fontWeight="700" marginTop="1.5rem !important">
        Select vehicle or powered asset<StarSpan>*</StarSpan>
      </TextWrapper>
      {/* <CFSTAutocompleteSearch
        placeHolder="Search by name, ESN or registration number"
        groupedOptions={vehicles}
        selectedOption={selectedVinOrPA}
        onChangeHandler={searchHandler}
        isBlockingErrorOccured={isBlockingErrorOccured}
      /> */}
      <AccessibleAutocompleteDropdown
        id="cfst-autocomplete-dropdown"
        options={vehicles}
        onSelect={searchHandler}
        selectedOption={selectedVinOrPA}
        placeholder="Search by name, ESN or registration number"
        idPrefix="vehicles-dropdown"
      />
      {selectedVinOrPA && (
        <SelectedVINOrPA
          key={selectedVinOrPA.label}
          selectedVinOrPA={selectedVinOrPA}
          setSelectedVinOrPA={setSelectedVinOrPA}
          setSelectedAccessories={setSelectedAccessories}
          setHighlightAccessories={setHighlightAccessories}
          getDeviceType={getDeviceType}
          isBlockingErrorOccured={isBlockingErrorOccured}
        />
      )}
    </Wrapper>
  );
}

CurrentVehicleSearch.propTypes = {
  selectedVinOrPA: PropTypes.any,
  setSelectedVinOrPA: PropTypes.func,
  searchHandler: PropTypes.func,
  setSelectedAccessories: PropTypes.func,
  setHighlightAccessories: PropTypes.func,
  getDeviceType: PropTypes.func,
  isWarning: PropTypes.bool,
  isBlockingErrorOccured: PropTypes.bool,
};

export default CurrentVehicleSearch;